import { render, staticRenderFns } from "./AdviceView.vue?vue&type=template&id=27335704&scoped=true&"
import script from "./AdviceView.vue?vue&type=script&lang=js&"
export * from "./AdviceView.vue?vue&type=script&lang=js&"
import style0 from "./AdviceView.vue?vue&type=style&index=0&id=27335704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27335704",
  null
  
)

export default component.exports